"use client";

import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";
import { CheckIcon } from "@radix-ui/react-icons";
import * as React from "react";

import { cn } from "@/utils/lib";
import { resolveClassName } from "@/utils/resolve-class-name";

const Checkbox = ({
  checked,
  className,
  defaultChecked,
  indeterminate,
  ...props
}: Omit<
  React.ComponentProps<typeof CheckboxPrimitive.Root>,
  "checked" | "defaultChecked" | "indeterminate"
> & {
  checked?: boolean | "indeterminate";
  defaultChecked?: boolean | "indeterminate";
  indeterminate?: boolean;
}) => {
  const isCheckedIndeterminate = checked === "indeterminate";
  const isDefaultCheckedIndeterminate = defaultChecked === "indeterminate";

  return (
    <CheckboxPrimitive.Root
      checked={isCheckedIndeterminate ? false : checked}
      className={(state) =>
        cn(
          `
            peer inline-flex size-4
            shrink-0 items-center justify-center
            rounded-sm border border-primary shadow-sm focus-visible:ring-1
            focus-visible:ring-ring focus-visible:outline-hidden
            disabled:cursor-not-allowed disabled:opacity-50
          `,
          state.checked && "bg-primary text-primary-foreground",
          resolveClassName(className, state),
        )
      }
      defaultChecked={isDefaultCheckedIndeterminate ? false : defaultChecked}
      indeterminate={
        indeterminate ??
        (isCheckedIndeterminate || isDefaultCheckedIndeterminate)
      }
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
        <CheckIcon className="size-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
};
Checkbox.displayName = "Checkbox";

export { Checkbox };
